import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LoadingOverlay } from '@imprivata/nucleus';

/**
 * ResumeAuthSession Component
 *
 * Loading screen shown while an interrupted authentication session is being resumed.
 * The resume is dispatched by startNewSessionHandler, not from this component - starting
 * it on mount would be too late to beat the host wrapper's own restart.
 */
export class ResumeAuthSession extends Component {

  static propTypes = { stateToken: PropTypes.string, };

  render() {
    // stateToken is set for the whole resume, so it is the signal for "still resuming".
    // sessionService is not: it is cleared until the connection is re-established, which
    // would blank the mask for the outage window the user actually sees.
    if (this.props.stateToken) {
      return <LoadingOverlay showOverlay />;
    }
    return null;
  }
}

const mapStateToProps = state => {
  const { stateToken, } = state.login;
  return { stateToken, };
};

export default connect(mapStateToProps)(ResumeAuthSession);
